<template>
    <div class="wrapper-form-block-dadoscomplementares" :inert="pPreview">
      <p><strong>Dados complementares</strong></p>
      <br/>
      <div class="columns mb-0">
        <div class="column is-narrow" :class="{'allow-markup-error': markupErrorQuantidadeDeSocios}">
          <TrfNumberInput
            label="Quantos sócios?"
            placeholder="Digite"
            margin="0"
            id="form-block-quantidadedesocios"
            v-model="formData.quantidadeDeSocios"
            maxLength="2"
            max="99"
            min="1"
            ref="BlockQuantidadeDeSocios"
            :hasMarginBottomLabel="true"
            :required="required"
            v-e2e="'form-block-quantidadedesocios'"
            @update:modelValue="setQuantidadeDeSocios"
          ></TrfNumberInput>
          <p class="error-message" v-if="markupErrorQuantidadeDeSocios">
            Campo obrigatório
          </p>
        </div>
        <div class="column is-narrow" :class="{'allow-markup-error': markupErrorCapitalSocial}">
          <TrfInputValor
            label="Qual o valor do capital social?"
            placeholder=""
            id="form-block-capitalsocial"
            @update:model-value="setCapitalSocial"
            ref="BlockCapitalSocial"
            v-e2e="'form-block-capitalsocial'"
          ></TrfInputValor>
          <p class="error-message" v-if="markupErrorCapitalSocial">
            Campo obrigatório
          </p>
        </div>
        <div class="column" :class="{'allow-markup-error': markupErrorFaturamentoMensal}">
          <TrfInputValor
            label="Qual a estimativa de faturamento mensal?"
            placeholder=""
            id="form-block-faturamentomensal"
            @update:model-value="setFaturamentoMensal"
            ref="BlockFaturamentoMensal"
            v-e2e="'form-block-faturamentomensal'"
            :shouldBreakLine="false"
          ></TrfInputValor>
          <p class="error-message" v-if="markupErrorFaturamentoMensal">
            Campo obrigatório
          </p>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  
  export default {
    name: 'TrfBlocoDadosComplementares',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfNumberInput: defineAsyncComponent(() => import('../../Input/TrfNumberInput.vue')),
        TrfInputValor: defineAsyncComponent(() => import('../../Input/InputValor.vue'))
    },
    props: {
        pQuantidadeDeSocios: {
            type: Number,
            default: null
        },
        pCapitalSocial: {
            type: String,
            default: ''
        },
        pFaturamentoMensal: {
            type: String,
            default: ''
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        pEmpresa: {
          type: Object,
          default: () => {}
        },
        required: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        formData: {
            quantidadeDeSocios: this.pEmpresa?.quantidadeDeSocios? `${this.pEmpresa.quantidadeDeSocios}` : this.pQuantidadeDeSocios,
            capitalSocial: this.pEmpresa?.capitalSocial? `${this.pEmpresa.capitalSocial}` : this.pCapitalSocial,
            faturamentoMensal: this.pEmpresa?.faturamentoMensal? `${this.pEmpresa.faturamentoMensal}` : this.pFaturamentoMensal
        },
        dirtyState: {
          quantidadeDeSocios: this.pIsDirty,
          capitalSocial: this.pIsDirty,
          faturamentoMensal: this.pIsDirty
        },
        campoInicializado: false
      };
    },
    computed: {
      isInvalida() {
        return this.isQuantidadeDeSociosInvalida || this.isCapitalSocialInvalido || this.isFaturamentoMensalInvalido
      },
      isQuantidadeDeSociosInvalida() {
        if (!this.required) return false;
        return this.isDirty && this.formData.quantidadeDeSocios == null
      },
      isCapitalSocialInvalido() {
        if (!this.required) return false;
        return this.isDirty && !this.formData.capitalSocial
      },
      isFaturamentoMensalInvalido() {
        if (!this.required) return false;
        return this.isDirty && !this.formData.faturamentoMensal
      },
      isDirty: {
        get() {
          return this.dirtyState.quantidadeDeSocios && this.dirtyState.capitalSocial && this.dirtyState.faturamentoMensal;
        },
        set(valor) {
          for(let campo in this.dirtyState) {
            this.dirtyState[campo] = valor
          }
        }
      },
      markupErrorQuantidadeDeSocios() {
        return !this.pPreview && this.isQuantidadeDeSociosInvalida
      },
      markupErrorCapitalSocial() {
        return !this.pPreview && this.isCapitalSocialInvalido
      },
      markupErrorFaturamentoMensal() {
        return !this.pPreview && this.isFaturamentoMensalInvalido
      },
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
              if(this.required) {
                  this.$emit('set:validacao', !novo);
              }
            }
        },
        pEmpresa: {
          immediate: true,
          handler(novo, velho) {
            if(!novo) return;
            this.inicializarCampos()
          },
          deep: true
        }
    },
    methods: {
        inicializarCampos() {
          if(!this.$refs.BlockCapitalSocial || !this.$refs.BlockFaturamentoMensal) return;
          this.$refs.BlockCapitalSocial.inicializarInput(this.formData.capitalSocial);
          this.$refs.BlockFaturamentoMensal.inicializarInput(this.formData.faturamentoMensal);
          this.campoInicializado = true;
        },
        setQuantidadeDeSocios(quantidadeDeSocios) {
            if (!this.campoInicializado) return;
            this.formData.quantidadeDeSocios = quantidadeDeSocios? quantidadeDeSocios : null;
            this.emitFormData(this.formData)
            this.dirtyState.quantidadeDeSocios = true
        },
        setCapitalSocial(capitalSocial) {
          if (!this.campoInicializado) return;
          this.formData.capitalSocial = capitalSocial
          this.emitFormData(this.formData)
          this.dirtyState.capitalSocial = true
        },
        setFaturamentoMensal(faturamentoMensal) {
          if (!this.campoInicializado) return;
          this.formData.faturamentoMensal = faturamentoMensal
          this.emitFormData(this.formData)
          this.dirtyState.faturamentoMensal = true
        },
        emitFormData(formData = this.formData) {
          this.$emit('update:form-data', formData)
        }
    }
  };
  </script>
  